import apiClient from './api';

// 定义分页限制常量，从环境变量读取，默认20
const pageLimit = parseInt(process.env.REACT_APP_FETCH_LIMIT || process.env.FETCH_LIMIT || '20', 10);

class NotesService {
  /**
   * 管理员搜索笔记
   * @param {Object} params - 搜索参数
   * @param {string} params.userEmail - 用户邮箱
   * @param {string} params.keyword - 关键字
   * @param {number} params.page - 页码
   * @param {number} params.limit - 每页数量
   */
  async adminSearchNotes(params = {}) {
    const { userEmail, keyword, page = 1, limit = pageLimit } = params;
    
    const queryParams = new URLSearchParams();
    if (userEmail) queryParams.append('userEmail', userEmail);
    if (keyword) queryParams.append('keyword', keyword);
    queryParams.append('page', page.toString());
    queryParams.append('limit', limit.toString());
    
    const response = await apiClient.get(`/notes/admin/search?${queryParams.toString()}`);
    return response.data.data || response.data;
  }

  /**
   * 管理员删除单个笔记
   * @param {string} noteId - 笔记ID
   */
  async adminDeleteNote(noteId) {
    const response = await apiClient.delete(`/notes/admin/${noteId}`);
    return response.data.data || response.data;
  }

  /**
   * 管理员批量删除笔记
   * @param {string[]} noteIds - 笔记ID数组
   */
  async adminBatchDeleteNotes(noteIds) {
    const response = await apiClient.delete('/notes/admin/batch', {
      data: { noteIds }
    });
    return response.data.data || response.data;
  }
}

export const notesService = new NotesService(); 